import { Clock, FileText, Globe, Mail, Phone } from 'lucide-react';
import { ScrollLines, Reveal, Eyebrow } from '@/components/Reveal';
import EnquiryForm from '@/components/EnquiryForm';

export default function Contact() {
  return (
    <div className="bg-night text-bone">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 pb-24 pt-36 md:grid-cols-12 md:px-12 md:pb-32 md:pt-48">
        <div className="md:col-span-5">
          <Reveal>
            <Eyebrow>Request a quote</Eyebrow>
          </Reveal>
          <ScrollLines
            className="mt-6 block"
            lineClassName="font-serif text-5xl font-medium leading-[1.0] tracking-tight text-bone sm:text-6xl"
            lines={[
              'Tell us the shipment.',
              <em key="e" className="text-turmeric">We’ll make it move.</em>,
            ]}
          />
          <Reveal delay={0.25} className="mt-8 max-w-md space-y-5 text-sm leading-relaxed text-dune md:text-base">
            <p>
              Spice, volume, destination — that’s all we need to start. We supply export buyers
              and domestic buyers across India on the same graded lots. The trade desk replies
              with grade confirmation and an indicative quote within one business day.
            </p>
          </Reveal>

          <Reveal delay={0.35} className="mt-12 space-y-5" data-testid="contact-details">
            <div className="grid gap-4 sm:grid-cols-2">
              <div className="rounded-2xl border border-white/10 bg-coal/40 p-5" data-testid="contact-person-tj">
                <p className="text-[10px] font-medium uppercase tracking-[0.24em] text-dune">Founder</p>
                <p className="mt-1.5 font-serif text-2xl text-bone">TJ Mohan Raja</p>
                <a
                  href="tel:+917418042004"
                  data-testid="contact-phone-tj"
                  className="mt-2 inline-flex items-center gap-2 text-sm text-turmeric transition-colors duration-300 hover:text-bone"
                >
                  <Phone className="h-3.5 w-3.5" strokeWidth={1.5} />
                  +91 74180 42004
                </a>
                <p className="mt-3 text-[12px] leading-relaxed text-dune">
                  1483/6, Tara Apartments, 13th Main Road, Anna Nagar, Block J, Chennai, Tamil Nadu
                  600040, India
                </p>
              </div>
              <div className="rounded-2xl border border-white/10 bg-coal/40 p-5" data-testid="contact-partner">
                <p className="text-[10px] font-medium uppercase tracking-[0.24em] text-dune">Business Partner</p>
                <p className="mt-1.5 font-serif text-2xl text-bone">Abishek Pandian</p>
                <a
                  href="tel:+918056965236"
                  data-testid="contact-phone-partner"
                  className="mt-2 inline-flex items-center gap-2 text-sm text-turmeric transition-colors duration-300 hover:text-bone"
                >
                  <Phone className="h-3.5 w-3.5" strokeWidth={1.5} />
                  +91 80569 65236
                </a>
                <p className="mt-3 text-[12px] leading-relaxed text-dune">
                  70/9, Nega Complex, Main Road, Vasudevanallur, Tenkasi, Tamil Nadu 627758, India
                </p>
              </div>
            </div>
            <div className="space-y-3 text-sm text-bone/80">
              <p className="flex items-center gap-3" data-testid="contact-email">
                <Mail className="h-4 w-4 shrink-0 text-turmeric" strokeWidth={1.5} />
                <a href="mailto:tjmohan@equinoxspices.com" className="transition-colors duration-300 hover:text-turmeric">
                  tjmohan@equinoxspices.com
                </a>
              </p>
              <p className="flex items-center gap-3" data-testid="contact-markets">
                <Globe className="h-4 w-4 shrink-0 text-turmeric" strokeWidth={1.5} />
                Supplying export and domestic (India) buyers
              </p>
              <p className="flex items-center gap-3" data-testid="contact-gstin">
                <FileText className="h-4 w-4 shrink-0 text-turmeric" strokeWidth={1.5} />
                GSTIN 33FQEPM5841N1ZE
              </p>
              <p className="flex items-center gap-3" data-testid="contact-response">
                <Clock className="h-4 w-4 shrink-0 text-turmeric" strokeWidth={1.5} />
                We reply within one business day
              </p>
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-7">
          <Reveal delay={0.15}>
            <EnquiryForm />
          </Reveal>
        </div>
      </div>
    </div>
  );
}
